/**
 * OSD-specific news content for February 2026 release
 *
 * News articles announcing Multi-OSD support for each distributor:
 * - TAURON, PGE, ENEA, ENERGA
 */

export const TAURON_OSD_LUTY_2026_CONTENT = `# TAURON - Pełna obsługa wszystkich taryf 2026

Od teraz **TaryfyPrądu.pl** oferuje pełne wsparcie dla klientów **TAURON Dystrybucja** z obsługą wszystkich dostępnych taryf na rok 2026!

## 🎯 Co zyskujesz jako klient TAURON?

### Dostępne taryfy dla TAURON
| Taryfa | Typ | Opis |
|--------|-----|------|
| **G11** | Jednozónowa | Stała cena przez całą dobę |
| **G12** | Dwuzónowa | Tańszy prąd w nocy (22:00-6:00) |
| **G12w** | Dwuzónowa weekend | Tańszy prąd w weekendy i święta |
| **G12as** | Dwuzónowa antismog | Dla pomp ciepła - tańsza energia na ogrzewanie |
| **G13** | Trójstrefowa | Szczyt, pozaszczyt, noc |
| **G13s** | Trójstrefowa weekend | Jak G13 + tańsze weekendy |
| **G14** | Dynamiczna (2026) | Ceny zmieniają się co godzinę |

**TAURON oferuje najwięcej taryf spośród wszystkich dystrybutorów w Polsce!**

## 🔧 Nowe funkcje dla klientów TAURON

### 1. Import danych z eLicznika
- Pobierz dane godzinowe ze swojego licznika TAURON
- Automatyczna analiza wzorców zużycia
- Precyzyjne porównanie kosztów na podstawie RZECZYWISTEGO zużycia

### 2. Kalkulator Profesjonalny (tylko TAURON)
- Symulacja taryfy G14 (dynamicznej)
- Porównanie z taryfami tradycyjnymi
- Analiza opłacalności fotowoltaiki

### 3. Aktualne ceny 2026
- Stawki zatwierdzone przez URE
- Opłaty dystrybucyjne TAURON
- Wszystkie składniki rachunku

## 📍 Twój region TAURON

TAURON Dystrybucja obsługuje:
- **dolnośląskie** (całe)
- **małopolskie** (całe)
- **opolskie** (całe)
- **śląskie** (całe)
- części: świętokrzyskiego, podkarpackiego, łódzkiego

## ⚠️ Ważna informacja

Nasz kalkulator służy **wyłącznie celom edukacyjnym i informacyjnym**. Przed zmianą taryfy:
- Skontaktuj się z TAURON Dystrybucja
- Sprawdź aktualne warunki umowy
- Upewnij się, że zmiana jest dla Ciebie korzystna

---

**Sprawdź, ile możesz zaoszczędzić!** Wybierz swój wzorzec zużycia i porównaj taryfy.
`;

export const PGE_OSD_LUTY_2026_CONTENT = `# PGE - Teraz z pełnym wsparciem w kalkulatorze!

Świetna wiadomość dla klientów **PGE Dystrybucja**! Od teraz **TaryfyPrądu.pl** obsługuje wszystkie taryfy PGE na rok 2026.

## 🎯 Co zyskujesz jako klient PGE?

### Dostępne taryfy dla PGE
| Taryfa | Typ | Opis |
|--------|-----|------|
| **G11** | Jednozónowa | Stała cena przez całą dobę |
| **G12** | Dwuzónowa | Tańszy prąd w nocy (22:00-6:00) |
| **G12w** | Dwuzónowa weekend | Tańszy prąd w weekendy i święta |
| **G12n** | Dwuzónowa nocna | Specjalna taryfa nocna PGE |

**Taryfa G12n jest dostępna tylko u PGE!**

## 📊 Porównaj swoje koszty

### Kalkulator podstawowy
1. Wybierz **PGE** jako dystrybutora
2. Wprowadź swoje miesięczne zużycie
3. Zobacz porównanie wszystkich dostępnych taryf
4. Sprawdź potencjalne oszczędności

### Nowe funkcje
- **Automatyczny wybór roku** - porównaj ceny 2025 vs 2026
- **Szczegółowy rozkład kosztów** - energia, dystrybucja, opłaty
- **Rekomendacja najlepszej taryfy** - na podstawie Twojego zużycia

## 📍 Twój region PGE

PGE Dystrybucja obsługuje:
- **mazowieckie** (większość)
- **łódzkie** (większość)
- **lubelskie** (całe)
- **podlaskie** (całe)
- części: podkarpackiego, świętokrzyskiego

**PGE to największy dystrybutor w Polsce - obsługuje ponad 5,5 miliona klientów!**

## 💡 Czy warto zmienić taryfę?

Dla klientów PGE najczęściej opłaca się:
- **G11** → dla stałego, równomiernego zużycia
- **G12** → jeśli używasz dużo prądu w nocy
- **G12w** → jeśli weekendy to Twój główny czas zużycia
- **G12n** → dla nocnych "sów" i urządzeń działających w nocy

## ⚠️ Ważna informacja

Nasz kalkulator służy **wyłącznie celom edukacyjnym i informacyjnym**. Przed zmianą taryfy:
- Skontaktuj się z PGE Dystrybucja
- Sprawdź aktualne warunki umowy
- Potwierdź dostępność taryfy w Twojej lokalizacji

---

**Sprawdź swój potencjał oszczędności!** Wypróbuj kalkulator z nowym wsparciem dla PGE.
`;

export const ENEA_OSD_LUTY_2026_CONTENT = `# ENEA - Pełna obsługa w kalkulatorze TaryfyPrądu.pl!

Klienci **ENEA Operator** mogą teraz korzystać z pełnego wsparcia kalkulatora TaryfyPrądu.pl! Sprawdź, która taryfa jest dla Ciebie najkorzystniejsza.

## 🎯 Co zyskujesz jako klient ENEA?

### Dostępne taryfy dla ENEA
| Taryfa | Typ | Opis |
|--------|-----|------|
| **G11** | Jednozónowa | Stała cena przez całą dobę |
| **G12** | Dwuzónowa | Tańszy prąd w nocy (22:00-6:00) |
| **G12w** | Dwuzónowa weekend | Tańszy prąd w weekendy i święta |
| **G12as** | Antismogowa | Dla pomp ciepła i ogrzewania elektrycznego |

**ENEA oferuje taryfę G12as dla klientów z pompami ciepła!**

## 🌍 Twój region ENEA

ENEA Operator obsługuje zachodnią Polskę:
- **wielkopolskie** (większość)
- **zachodniopomorskie** (większość)
- **kujawsko-pomorskie** (część)
- **lubuskie** (całe)
- części: dolnośląskiego, pomorskiego

**Ponad 2,6 miliona klientów w regionie ENEA!**

## 🔥 Taryfa G12as dla pomp ciepła

Jeśli masz **pompę ciepła** lub **ogrzewanie elektryczne**, sprawdź taryfę G12as:
- Tańsza energia w strefie antismogowej
- Idealna dla ogrzewania elektrycznego
- Korzyści przy większym zużyciu zimą

## 📊 Jak porównać taryfy ENEA?

1. Otwórz [Kalkulator Podstawowy](/kalkulatory/podstawowy)
2. Wybierz **ENEA** z listy dystrybutorów
3. Wprowadź swoje miesięczne zużycie (z faktury)
4. Zobacz ranking taryf od najtańszej

### Przykład oszczędności
Dla zużycia 300 kWh/miesiąc:
- Zmiana z G11 na G12 może dać **8-15% oszczędności**
- Zmiana na G12w (przy weekendowym zużyciu) nawet **20%**

## ⚠️ Ważna informacja

Nasz kalkulator służy **wyłącznie celom edukacyjnym i informacyjnym**. Przed zmianą taryfy:
- Skontaktuj się z ENEA Operator
- Zweryfikuj dostępność taryfy pod Twoim adresem
- Sprawdź warunki zmiany w umowie

---

**Zoptymalizuj swoje rachunki!** Wypróbuj kalkulator z pełnym wsparciem dla ENEA.
`;

export const ENERGA_OSD_LUTY_2026_CONTENT = `# ENERGA - Twój kalkulator taryf na Północy!

**ENERGA-Operator** teraz z pełnym wsparciem w TaryfyPrądu.pl! Klienci z północnej Polski mogą porównać wszystkie dostępne taryfy.

## 🎯 Co zyskujesz jako klient ENERGA?

### Dostępne taryfy dla ENERGA
| Taryfa | Typ | Opis |
|--------|-----|------|
| **G11** | Jednozónowa | Stała cena przez całą dobę |
| **G12** | Dwuzónowa | Tańszy prąd w nocy (22:00-6:00) |
| **G12w** | Dwuzónowa weekend | Tańszy prąd w weekendy i święta |
| **G12as** | Antismogowa | Dla pomp ciepła |
| **G12r** | Dwuzónowa rozszerzona | Specjalna taryfa ENERGA! |

**Taryfa G12r jest unikalna dla ENERGA - wydłużona strefa nocna!**

## 🌊 Twój region ENERGA

ENERGA-Operator obsługuje północną Polskę:
- **pomorskie** (większość)
- **warmińsko-mazurskie** (całe)
- części: kujawsko-pomorskiego, mazowieckiego, wielkopolskiego

**Ponad 3,2 miliona klientów na Północy!**

## 🌙 Specjalna taryfa G12r

Tylko w ENERGA dostępna jest taryfa **G12r** z rozszerzoną strefą nocną:
- Dłuższe godziny taniej energii
- Idealna dla nocnych marków energii
- Korzystna przy ogrzewaniu akumulacyjnym

## 📊 Porównaj taryfy ENERGA

### Krok po kroku
1. Otwórz [Kalkulator](/kalkulatory/podstawowy)
2. Wybierz **ENERGA** z listy OSD
3. Podaj zużycie lub wybierz profil gospodarstwa
4. Sprawdź, która taryfa Ci się opłaca

### Kiedy zmienić taryfę?
- **G11 → G12**: Jeśli zużywasz dużo prądu po 22:00
- **G11 → G12w**: Jeśli weekendy to Twój główny czas w domu
- **G12 → G12r**: Jeśli możesz przesunąć zużycie na późną noc
- **G12as**: Jeśli masz pompę ciepła lub ogrzewanie elektryczne

## ⚠️ Ważna informacja

Nasz kalkulator służy **wyłącznie celom edukacyjnym i informacyjnym**. Przed zmianą taryfy:
- Skontaktuj się z ENERGA-Operator
- Sprawdź dostępność G12r w Twojej lokalizacji
- Zweryfikuj warunki zmiany taryfy

---

**Odkryj potencjał oszczędności!** Przetestuj kalkulator z nowymi taryfami ENERGA.
`;
